import { render } from "./ExportCharts.vue?vue&type=template&id=56011ab8"
import script from "./ExportCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportCharts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/ExportCharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56011ab8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56011ab8', __exports__)) {
    api.reload('56011ab8', __exports__)
  }
  
  module.hot.accept("./ExportCharts.vue?vue&type=template&id=56011ab8", () => {
    api.rerender('56011ab8', render)
  })

}


export default __exports__